<form class="form">
  <div class="form-wrapper">
    <div class="row is-flex">
      <div class="col s12 login-wrapper">
        <button
          (click)="onLogin()"
          cdkFocusInitial
          class="btn btn-primary"
          name="login"
          type="button"
          [disabled]="pending$ | async"
          style="margin-bottom: 12px; width: 250px; margin-top: 10px"
        >
          <!-- style="width:  30px; margin-bottom: 12px;"-->
          Login
          <fa-icon *ngIf="pending$ | async" icon="spinner" [spin]="true"></fa-icon>
        </button>
      </div>
    </div>
  </div>
</form>
